var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex fs-bold fs-title justify-center mt-60px"},[_vm._v("Ehhez a kalkulációhoz nincs hozzáférésed!")])}
var staticRenderFns = []

export { render, staticRenderFns }